import { todayIn } from "@/utils/calendar-dates";

import type { TenantProviderSettings, WorkflowState } from "./types";

export const DELIVERY_ELIGIBLE_WORKFLOW_STATES: readonly WorkflowState[] = [
  "Approved",
  "Final Descriptor Signed Off",
  "Exported and Locked",
];

export function isDeliveryStatusApplicable(workflowState: WorkflowState): boolean {
  return DELIVERY_ELIGIBLE_WORKFLOW_STATES.includes(workflowState);
}

/**
 * Whether a record may still carry a delivery status it was already given.
 *
 * Setting one requires approval; keeping one only requires that approval
 * happened. `Archived` is reachable from `Approved`, and archiving does not
 * retract the delivery decision recorded while the programme was live, so a
 * status set before the archive stays on the row.
 */
export function mayRetainDeliveryStatus(workflowState: WorkflowState): boolean {
  return isDeliveryStatusApplicable(workflowState) || workflowState === "Archived";
}

/** Today where the tenant publishes, the day an end of life is read against. */
export function tenantToday(provider: TenantProviderSettings | undefined, now: Date): string {
  return todayIn(provider?.settings.publicationTimeZone ?? "Europe/Dublin", now).toString();
}

/**
 * Whether a programme has reached its end of life. Retired from the date
 * itself, so a programme ending on the 31st is retired on the 31st.
 */
export function programmeRetired(endOfLife: string | undefined, today: string): boolean {
  // ISO calendar dates order as strings.
  return endOfLife !== undefined && endOfLife <= today;
}
